import axios from "axios";
import React, { useEffect, useState } from "react";
import { axiosConfig } from "../Helpers/AxiosRequest";
import { useModal } from "../Contexts/ModalContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faXmark } from "@fortawesome/free-solid-svg-icons";
import uploadImages from "../Helpers/UploadImages";
import { API_URL } from "../Helpers/api";

const NewAddForm = ({ activeTab, setAdds, currentAdd }) => {
  const { closeModal } = useModal();
  const socialApps = ["facebook", "whatsapp", "instagram", "twitter", "pinterest", "linkedin"];
  const days = ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"];
  const [hours, setHours] = useState([]);
  const [minutes, setMinutes] = useState([]);
  const [addForm, setAddForm] = useState({
    name: "",
    description: "",
    email: "",
    images0: "",
    address: "",
    location: "",
    phone0: "",
    phone1: "",
    phone2: "",
    mobilePhone0: "",
    mobilePhone1: "",
    mobilePhone2: "",
    whatsapp: "",
    facebook: "",
    instagram: "",
    linkedin: "",
    twitter: "",
    pinterest: "",
  });
  const [timetable, setTimetable] = useState([]);
  const [timeForm, setTimeForm] = useState({
    day: "Domingo",
    openHour: "00",
    openMinute: "00",
    closeHour: "00",
    closeMinute: "00",
    note: "",
  });
  const [loadingImages, setLoadingImages] = useState([]);
  const [eventForm, setEventForm] = useState({
    name: "",
    images: [],
    description: "",
    date: "",
    moreInfo: "",
    location: "",
    city: "",
    register: "",
    contact0: {
      name: "",
      country: "",
      phone: "",
    },
    contact1: {
      name: "",
      country: "",
      phone: "",
    },
    contact2: {
      name: "",
      country: "",
      phone: "",
    },
  });

  useEffect(() => {
    const hoursArr = [];
    const minutesArr = [];
    for (let i = 0; i < 60; i++) {
      if (i < 24) {
        const h = String(i).padStart(2, "0");
        hoursArr.push(h);
      }
      if (i % 5 === 0) {
        const m = String(i).padStart(2, "0");
        minutesArr.push(m);
      }
    }
    setHours(hoursArr);
    setMinutes(minutesArr);

    if (currentAdd) {
      // console.log(currentAdd);
      setEventForm({
        name: currentAdd.name,
        images: currentAdd.images,
        description: currentAdd.description,
        date: currentAdd.date,
        moreInfo: currentAdd.moreInfo,
        location: currentAdd.location,
        city: currentAdd.city,
        register: currentAdd.register,
        contact0: currentAdd.contacts[0],
        contact1:
          currentAdd.contacts.length > 1
            ? currentAdd.contacts[1]
            : {
                name: "",
                country: "",
                phone: "",
              },
        contact2:
          currentAdd.contacts.length > 2
            ? currentAdd.contacts[2]
            : {
                name: "",
                country: "",
                phone: "",
              },
      });
    }
  }, []);

  const handleInputChange = (e) => {
    setAddForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleTimeFormChange = (e) => {
    setTimeForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleAddTime = (e) => {
    e.preventDefault();
    const time = {
      day: timeForm.day,
      open: `${timeForm.openHour}:${timeForm.openMinute}`,
      close: `${timeForm.closeHour}:${timeForm.closeMinute}`,
      note: null,
    };
    setTimetable((prev) => [...prev, time]);
  };

  const handleImageDelete = (e, name) => {
    e.preventDefault();

    setLoadingImages((prev) => prev.filter((image) => image.name !== name));
  };

  const handleAddSubmit = async (e) => {
    e.preventDefault();

    const savedImages = await uploadImages(loadingImages);

    const data = {
      name: null,
      description: null,
      email: null,
      phone: [],
      mobilePhone: [],
      address: null,
      location: null,
      social: {
        whatsapp: null,
        facebook: null,
        instagram: null,
        linkedin: null,
        twitter: null,
        pinterest: null,
      },
      images: savedImages,
    };

    if (activeTab === "gastronomic") {
      data.timetable = timetable;
    }

    Object.keys(addForm).map((key) => {
      if (socialApps.includes(key)) {
        return (data.social[key] = addForm[key] === "" ? null : addForm[key]);
      }
      if (key.toLowerCase().includes("phone")) {
        if (addForm[key] === "") return null;
        const item = key.slice(0, -1);
        const index = key.slice(-1);
        const updatedArray = data[item];
        updatedArray[index] = addForm[key];
        return (data[item] = updatedArray);
      }
      if (addForm[key] === "") {
        return (data[key] = null);
      }
      return (data[key] = addForm[key]);
    });

    axios(axiosConfig("POST", `${API_URL}/advertising/create/${activeTab}`, data))
      .then((res) => {
        if (res.data.success) {
          setAdds((prev) => ({
            ...prev,
            [activeTab]: [...prev[activeTab], res.data.newAdd],
          }));
          return closeModal();
        }
      })
      .catch((err) => console.error(err));
  };

  const uploadToGallery = async (e) => {
    e.preventDefault();

    try {
      const images = await uploadImages(loadingImages, true);

      if (images.length > 0) {
        setAdds((prev) => ({
          ...prev,
          gallery: [...prev.gallery, ...images],
        }));
        return closeModal();
      }
    } catch (err) {
      console.error(err.message);
    }
  };

  const handleEventFormChange = (e) => {
    e.preventDefault();

    if (e.target.name.includes("contact")) {
      const contactArr = e.target.name.split("-");
      const contact = `${contactArr[0]}${contactArr[1]}`;
      return setEventForm((prev) => ({
        ...prev,
        [contact]: { ...prev[contact], [contactArr[2]]: e.target.value },
      }));
    }

    if (e.target.name !== "image") {
      return setEventForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
    } else {
      if (e.target.files.length < 1) {
        return;
      } else {
        return setEventForm((prev) => ({ ...prev, images: [e.target.files[0]] }));
      }
    }
  };

  const handleEventImageDelete = (e) => {
    e.preventDefault();
    setEventForm((prev) => ({ ...prev, images: [] }));
  };

  const handleEventFormSubmit = async (e) => {
    e.preventDefault();

    const savedImages = await uploadImages(eventForm.images);

    const data = {
      name: "",
      date: "",
      description: "",
      city: "",
      location: "",
      moreInfo: "",
      images: [],
      register: "",
      contacts: [],
    };

    Object.keys(eventForm).map((key) => {
      if (key === "images") {
        return (data.images = savedImages);
      }
      if (key.toLowerCase().includes("contact")) {
        if (eventForm[key].phone === "") {
          return null;
        }
        return data.contacts.push(eventForm[key]);
      }
      return (data[key] = eventForm[key]);
    });

    // console.log(data);

    axios(axiosConfig("POST", `${API_URL}/events/create`, data))
      .then(({ data }) => {
        if (data.success)
          setAdds((prev) => ({
            ...prev,
            events: [...prev.events, data.newEvent],
          }));
        return closeModal();
      })
      .catch((err) => console.error(err.message));
  };

  if (activeTab === "events") {
    return (
      <form onSubmit={handleEventFormSubmit}>
        <div className="form-group mb-3">
          <label htmlFor="name">Nombre</label>
          <input
            type="text"
            name="name"
            id="name"
            className="form-control"
            value={eventForm.name}
            onChange={handleEventFormChange}
          />
        </div>
        <div className="form-group mb-3">
          <label htmlFor="city">Ciudad</label>
          <input
            type="text"
            name="city"
            id="city"
            className="form-control"
            value={eventForm.city}
            onChange={handleEventFormChange}
          />
        </div>
        <div className="form-group mb-3">
          <label htmlFor="location">Ubicación (Link Google Maps)</label>
          <input
            type="text"
            name="location"
            id="location"
            className="form-control"
            value={eventForm.location}
            onChange={handleEventFormChange}
          />
        </div>
        <div className="form-group mb-3">
          <label htmlFor="description">Descripción</label>
          <textarea
            type="text"
            name="description"
            id="description"
            className="form-control"
            value={eventForm.description}
            onChange={handleEventFormChange}
            rows={5}
          />
        </div>
        <div className="form-group mb-3">
          <label htmlFor="moreInfo">Más información</label>
          <textarea
            type="text"
            name="moreInfo"
            id="moreInfo"
            className="form-control"
            value={eventForm.moreInfo}
            onChange={handleEventFormChange}
            rows={5}
          />
        </div>
        <div className="form-group mb-3">
          <label htmlFor="register">Inscripciones</label>
          <input
            type="text"
            name="register"
            id="register"
            className="form-control"
            value={eventForm.register}
            onChange={handleEventFormChange}
          />
        </div>
        <div className="form-group mb-3">
          <span>Contactos</span>
          <div className="row g-2">
            <div className="col-1 d-flex">
              <div className="m-auto">1</div>
            </div>
            <div className="col-4">
              <input
                type="text"
                name="contact-0-name"
                id="contact-0-name"
                className="form-control"
                onChange={handleEventFormChange}
                value={eventForm.contact0.name}
                placeholder="Nombre..."
              />
            </div>
            <div className="col-3">
              <select
                className="form-select"
                name="contact-0-country"
                id="contact-0-country"
                onChange={handleEventFormChange}
                value={eventForm.contact0.country}
              >
                <option value="" key="" hidden>
                  Selecciona el país...
                </option>
                <option value="br" key="br">
                  Brasil
                </option>
                <option value="ar" key="ar">
                  Argentina
                </option>
                <option value="uy" key="uy">
                  Uruguay
                </option>
              </select>
            </div>
            <div className="col-4">
              <input
                type="text"
                name="contact-0-phone"
                id="contact-0-phone"
                className="form-control"
                onChange={handleEventFormChange}
                value={eventForm.contact0.phone}
                placeholder="Teléfono..."
              />
            </div>
            <div className="col-1 d-flex">
              <div className="m-auto">2</div>
            </div>
            <div className="col-4">
              <input
                type="text"
                name="contact-1-name"
                id="contact-1-name"
                className="form-control"
                onChange={handleEventFormChange}
                value={eventForm.contact1.name}
                placeholder="Nombre..."
              />
            </div>
            <div className="col-3">
              <select
                className="form-select"
                name="contact-1-country"
                id="contact-1-country"
                onChange={handleEventFormChange}
                value={eventForm.contact1.country}
              >
                <option value="" key="" hidden>
                  Selecciona el país...
                </option>
                <option value="br" key="br">
                  Brasil
                </option>
                <option value="ar" key="ar">
                  Argentina
                </option>
                <option value="uy" key="uy">
                  Uruguay
                </option>
              </select>
            </div>
            <div className="col-4">
              <input
                type="text"
                name="contact-1-phone"
                id="contact-1-phone"
                className="form-control"
                onChange={handleEventFormChange}
                value={eventForm.contact1.phone}
                placeholder="Teléfono..."
              />
            </div>
            <div className="col-1 d-flex">
              <div className="m-auto">3</div>
            </div>
            <div className="col-4">
              <input
                type="text"
                name="contact-2-name"
                id="contact-2-name"
                className="form-control"
                onChange={handleEventFormChange}
                value={eventForm.contact2.name}
                placeholder="Nombre..."
              />
            </div>
            <div className="col-3">
              <select
                className="form-select"
                name="contact-2-country"
                id="contact-2-country"
                onChange={handleEventFormChange}
                value={eventForm.contact2.country}
              >
                <option value="" key="" hidden>
                  Selecciona el país...
                </option>
                <option value="br" key="br">
                  Brasil
                </option>
                <option value="ar" key="ar">
                  Argentina
                </option>
                <option value="uy" key="uy">
                  Uruguay
                </option>
              </select>
            </div>
            <div className="col-4">
              <input
                type="text"
                name="contact-2-phone"
                id="contact-2-phone"
                className="form-control"
                onChange={handleEventFormChange}
                value={eventForm.contact2.phone}
                placeholder="Teléfono..."
              />
            </div>
          </div>
        </div>
        <div className="form-group mb-3">
          <div className="d-flex">
            <div className="w-25 me-2">
              <label htmlFor="date">Fecha</label>
              <input
                type="date"
                name="date"
                id="date"
                className="form-control"
                value={eventForm.date}
                onChange={handleEventFormChange}
              />
            </div>
            <div className="w-75">
              <label htmlFor="image">Imágen</label>
              <input
                type="file"
                name="image"
                id="image"
                className={`form-control ${eventForm.images.length > 0 && "disabled"}`}
                onChange={handleEventFormChange}
              />
            </div>
          </div>
        </div>
        <button className="btn btn-success w-100">Guardar</button>
        {eventForm.images.length > 0 && (
          <div className="row justify-content-center mt-3">
            <div className="col-4 position-relative">
              <img
                src={URL.createObjectURL(eventForm.images[0])}
                alt={eventForm.name}
                className="img-thumbnail"
              />
              <button
                className="btn btn-danger btn-sm position-absolute top-0 end-0"
                onClick={(e) => handleEventImageDelete(e)}
              >
                <FontAwesomeIcon icon={faXmark} />
              </button>
            </div>
          </div>
        )}
      </form>
    );
  }

  if (activeTab === "gallery") {
    return (
      <form onSubmit={uploadToGallery}>
        <div className="form-group">
          <label htmlFor="images0">Imágenes</label>
          <input
            type="file"
            name="images0"
            id="images0"
            className="form-control"
            onChange={(e) => setLoadingImages((prev) => [...prev, e.target.files[0]])}
          />
        </div>
        {loadingImages.length > 0 && (
          <div className="row g-1 mt-3 align-items-center">
            {loadingImages.map((image) => (
              <div className="col-md-2 col-sm-3 col-4 position-relative" key={image.name}>
                <img src={URL.createObjectURL(image)} alt={image.name} className="img-thumbnail" />
                <button
                  className="btn btn-danger btn-sm position-absolute top-0 end-0"
                  onClick={(e) => handleImageDelete(e, image.name)}
                >
                  <FontAwesomeIcon icon={faXmark} />
                </button>
              </div>
            ))}
          </div>
        )}
        <button className="btn btn-success w-100 mt-3">Subir imágenes</button>
      </form>
    );
  }

  return (
    <form className="row g-3 align-items-center" onSubmit={handleAddSubmit}>
      <div className="col-md-3">
        <label htmlFor="name">Nombre:</label>
      </div>
      <div className="col-md-9">
        <input
          type="text"
          name="name"
          id="name"
          className="form-control"
          onChange={handleInputChange}
          value={addForm.name}
        />
      </div>
      <div className="col-md-3">
        <label htmlFor="images0">Imágen:</label>
      </div>
      <div className="col-md-9">
        <input
          type="file"
          name="images0"
          id="images0"
          className="form-control"
          onChange={(e) => setLoadingImages((prev) => [...prev, e.target.files[0]])}
          // value={addForm.images0}
        />
        {loadingImages.length > 0 && (
          <div className="row g-1 mt-3 align-items-center">
            {loadingImages.map((image) => (
              <div className="col-md-2 col-sm-3 col-4 position-relative" key={image.name}>
                <img src={URL.createObjectURL(image)} alt={image.name} className="img-thumbnail" />
                <button
                  className="btn btn-danger btn-sm position-absolute top-0 end-0"
                  onClick={(e) => handleImageDelete(e, image.name)}
                >
                  <FontAwesomeIcon icon={faXmark} />
                </button>
              </div>
            ))}
          </div>
        )}
      </div>
      <div className="col-md-3">
        <label htmlFor="description">Descripción:</label>
      </div>
      <div className="col-md-9">
        <textarea
          type="text"
          name="description"
          id="description"
          className="form-control"
          onChange={handleInputChange}
          value={addForm.description}
          rows={5}
        ></textarea>
      </div>
      <div className="col-md-3">
        <label htmlFor="address">Dirección:</label>
      </div>
      <div className="col-md-9">
        <input
          type="text"
          name="address"
          id="address"
          className="form-control"
          onChange={handleInputChange}
          value={addForm.address}
        />
      </div>
      <div className="col-md-3">
        <label htmlFor="location">Ubicación:</label>
      </div>
      <div className="col-md-9">
        <input
          type="text"
          name="location"
          id="location"
          className="form-control"
          onChange={handleInputChange}
          value={addForm.location}
        />
      </div>
      <div className="col-md-3">
        <label htmlFor="email">Email:</label>
      </div>
      <div className="col-md-9">
        <input
          type="email"
          name="email"
          id="email"
          className="form-control"
          onChange={handleInputChange}
          value={addForm.email}
        />
      </div>
      {activeTab === "gastronomic" && (
        <>
          <div className="col-md-3">
            <label htmlFor="">Horarios:</label>
          </div>
          <div className="col-md-9">
            <div className="row g-3">
              <div className="col-lg-2 col-12">
                <select
                  name="day"
                  id="day"
                  className="form-select"
                  onChange={handleTimeFormChange}
                  value={timeForm.day}
                >
                  {days.map((day) => (
                    <option value={day} key={day}>
                      {day}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-lg-2 col-6">
                <select
                  name="openHour"
                  id="openHour"
                  className="form-select text-center"
                  onChange={handleTimeFormChange}
                  value={timeForm.openHour}
                >
                  {hours.map((hour) => (
                    <option value={hour} key={hour}>
                      {hour}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-lg-2 col-6">
                <select
                  name="openMinute"
                  id="openMinute"
                  className="form-select text-center"
                  onChange={handleTimeFormChange}
                  value={timeForm.openMinute}
                >
                  {minutes.map((minute) => (
                    <option value={minute} key={minute}>
                      {minute}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-lg-1 col-12 d-flex">
                <div className="m-auto">-</div>
              </div>
              <div className="col-lg-2 col-6">
                <select
                  name="closeHour"
                  id="closeHour"
                  className="form-select text-center"
                  onChange={handleTimeFormChange}
                  value={timeForm.closeHour}
                >
                  {hours.map((hour) => (
                    <option value={hour} key={hour}>
                      {hour}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-lg-2 col-6">
                <select
                  name="closeMinute"
                  id="closeMinute"
                  className="form-select text-center"
                  onChange={handleTimeFormChange}
                  value={timeForm.closeMinute}
                >
                  {minutes.map((minute) => (
                    <option value={minute} key={minute}>
                      {minute}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-lg-1 col-12 d-flex">
                <button className="btn btn-success w-100" onClick={handleAddTime}>
                  <FontAwesomeIcon icon={faPlus} />
                </button>
              </div>
            </div>
            <div className="col-12">
              {timetable.map((time) => (
                <div>
                  <b>{time.day}:</b>{" "}
                  <span>
                    {time.open} - {time.close} {time.note ? `(${time.note})` : ""}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </>
      )}
      <div className="col-md-3">
        <label htmlFor="">Teléfonos fijos:</label>
      </div>
      <div className="col-md-9">
        <div className="row g-2">
          <div className="col-md-4">
            <input
              type="number"
              name="phone0"
              id="phone0"
              className="form-control"
              onChange={handleInputChange}
              value={addForm.phone0}
            />
          </div>
          <div className="col-md-4">
            <input
              type="number"
              name="phone1"
              id="phone1"
              className="form-control"
              onChange={handleInputChange}
              value={addForm.phone1}
            />
          </div>
          <div className="col-md-4">
            <input
              type="number"
              name="phone2"
              id="phone2"
              className="form-control"
              onChange={handleInputChange}
              value={addForm.phone2}
            />
          </div>
        </div>
      </div>
      <div className="col-md-3">
        <label htmlFor="">Teléfonos celulares:</label>
      </div>
      <div className="col-md-9">
        <div className="row g-2">
          <div className="col-md-4">
            <input
              type="number"
              name="mobilePhone0"
              id="mobilePhone0"
              className="form-control"
              onChange={handleInputChange}
              value={addForm.mobilePhone0}
            />
          </div>
          <div className="col-md-4">
            <input
              type="number"
              name="mobilePhone1"
              id="mobilePhone1"
              className="form-control"
              onChange={handleInputChange}
              value={addForm.mobilePhone1}
            />
          </div>
          <div className="col-md-4">
            <input
              type="number"
              name="mobilePhone2"
              id="mobilePhone2"
              className="form-control"
              onChange={handleInputChange}
              value={addForm.mobilePhone2}
            />
          </div>
        </div>
      </div>
      <div className="col-md-3">
        <label htmlFor="whatsapp">Whatsapp:</label>
      </div>
      <div className="col-md-9">
        <input
          type="text"
          name="whatsapp"
          id="whatsapp"
          className="form-control"
          onChange={handleInputChange}
          value={addForm.whatsapp}
        />
      </div>
      <div className="col-md-3">
        <label htmlFor="facebook">Facebook:</label>
      </div>
      <div className="col-md-9">
        <input
          type="text"
          name="facebook"
          id="facebook"
          className="form-control"
          onChange={handleInputChange}
          value={addForm.facebook}
        />
      </div>
      <div className="col-md-3">
        <label htmlFor="instagram">Instagram:</label>
      </div>
      <div className="col-md-9">
        <input
          type="text"
          name="instagram"
          id="instagram"
          className="form-control"
          onChange={handleInputChange}
          value={addForm.instagram}
        />
      </div>
      <div className="col-md-3">
        <label htmlFor="linkedin">LinkedIn:</label>
      </div>
      <div className="col-md-9">
        <input
          type="text"
          name="linkedin"
          id="linkedin"
          className="form-control"
          onChange={handleInputChange}
          value={addForm.linkedin}
        />
      </div>
      <div className="col-md-3">
        <label htmlFor="twitter">Twitter:</label>
      </div>
      <div className="col-md-9">
        <input
          type="text"
          name="twitter"
          id="twitter"
          className="form-control"
          onChange={handleInputChange}
          value={addForm.twitter}
        />
      </div>
      <div className="col-md-3">
        <label htmlFor="pinterest">Pinterest:</label>
      </div>
      <div className="col-md-9">
        <input
          type="text"
          name="pinterest"
          id="pinterest"
          className="form-control"
          onChange={handleInputChange}
          value={addForm.pinterest}
        />
      </div>
      <div className="col-12">
        <button className="btn btn-success w-100">Guardar</button>
      </div>
    </form>
  );
};

export default NewAddForm;
